export const isNonEmptyString = text => {
  if (typeof text === 'string') {
    return text.trim().length > 0
  }
  return false
}

export default isNonEmptyString
